<template>
	<b-modal ref="modal" centered no-close-on-backdrop no-fade>
		<template #modal-title>
			{{ tt('전자세금계산서 결제') }}
		</template>
		<template>
			<div class="input-wrapper">
				<h5>{{ tt('결제수단') }}</h5>
				<div class="Popup__input-field">
					<p>{{ tt('상호명') }}<span class="required">*</span></p>
					<input type="text" v-model="form.nameOfCompany" :placeholder="tt('법인명을 입력해주세요')" />
				</div>
				<div class="Popup__input-field">
					<p>
						{{ tt('사업자등록번호(10자리)') }}
						<span class="required">*</span>
					</p>
					<input
						type="text"
						:value="form.registrationNumber"
						@input="inputRegistrationNumber"
						:placeholder="tt('10자리 사업자등록번호를 입력해주세요')"
						:class="{ error: registrationNoError }"
						maxlength="12"
					/>
					<span class="input-error-msg" v-if="registrationNoError">
						<img src="@/assets/svg/input-icon-warning.svg" />
						<p>
							{{ tt('유효하지 않은 사업자등록번호입니다.') }}
						</p>
					</span>
				</div>
				<div class="Popup__input-field">
					<p>{{ tt('대표자명') }}<span class="required">*</span></p>
					<input type="text" v-model="form.nameOfRepresentative" :placeholder="tt('대표자 이름을 입력해주세요')" />
				</div>
				<div class="Popup__input-field">
					<p>{{ tt('이메일') }}<span class="required">*</span></p>
					<input type="email" :placeholder="tt('이메일 입력해주세요')" v-model="form.email" :class="{ error: emailNoError }" />
					<span class="error-text" v-if="emailNoError">
						<img src="@/assets/svg/input-icon-warning.svg" />
						<p>
							{{ tt('이메일을 형식에 맞게 입력해주세요') }}
						</p>
					</span>
				</div>
				<div class="Popup__input-field">
					<p>{{ tt('업태') }}</p>
					<input type="text" v-model="form.bizType" :placeholder="tt('업태를 입력해주세요')" />
				</div>
				<div class="Popup__input-field">
					<p>{{ tt('종목') }}</p>
					<input type="text" v-model="form.bizClass" :placeholder="tt('종목을 입력해주세요')" />
				</div>
				<div class="Popup__input-field">
					<p>{{ tt('전화번호') }}</p>
					<input
						type="text"
						:placeholder="tt('연락처를 입력해주세요')"
						maxlength="13"
						:value="form.phone"
						@input="autoHypenTel"
						:class="{ error: phoneNoError }"
					/>
					<span class="error-text" v-if="phoneNoError">
						<img src="@/assets/svg/input-icon-warning.svg" />
						<p>
							{{ tt('연락처를 형식에 맞게 입력해주세요') }}
						</p>
					</span>
				</div>
				<div class="Popup__input-field">
					<p>{{ tt('주소') }}</p>
					<AddressInput
						:hasPostcode="false"
						:postcode="form.postcode"
						:address="form.address"
						:addressDetail="form.addressDetail"
						addressPlaceholder="주소를 검색해주세요"
						@search="changeAddress"
					/>
				</div>
				<div class="noti-box">
					<p
						v-html="tt(`<b class='red'>${formatDepositExpireDate()}</b>까지 입금하지 않으면 라이선스가 <b class=red>비활성화</b>됩니다.`)"
					></p>
				</div>
			</div>
		</template>
		<template #modal-footer>
			<button class="Btn__yellow" :disabled="!isFormValid" @click="confirm">
				{{ tt('전자세금계산서 발급하기') }}
			</button>
		</template>
	</b-modal>
</template>
<script>
import AddressInput from '@/components/input/AddressInput.vue'
import MixinLicense from '@/mixins/license'
import MixinPayment from '@/mixins/payment'
export default {
	components: {
		AddressInput,
	},
	mixins: [MixinLicense, MixinPayment],
	data() {
		return {
			confirmFn: null,
		}
	},
	computed: {
		isFormValid() {
			const isNameOfRepresentativeValid = this.form?.nameOfRepresentative !== ''
			const isRegistrationNumberValid = this.form?.registrationNumber !== '' && this.form?.registrationNumber?.length === 12
			const isNameOfCompanyValid = this.form?.nameOfCompany !== ''
			const isEmailValid = this.form?.email !== '' && this.validEmail()

			return isNameOfRepresentativeValid && isRegistrationNumberValid && isNameOfCompanyValid && isEmailValid
		},
	},
	methods: {
		async show(confirmFn = null) {
			this.initData()
			await this.initPreviousEbil()
			this.confirmFn = confirmFn
			this.$refs['modal'].show()
		},
		async initPreviousEbil() {
			const response = await this.lookupPreviousEbillInfo()
			Object.assign(this.form, response.data)
		},
		hide() {
			this.$refs['modal'].hide()
		},
		async confirm() {
			if (!this.validPhone()) {
				this.phoneNoError = true
				return
			}
			if (!this.validEmail()) {
				this.emailNoError = true
				return
			}
			try {
				const { id } = await this.createEbill(this.form)
				if (this.confirmFn) this.confirmFn(id)
				this.$emit('confirm', id)
			} catch (err) {
				console.log(err)
				this.checkregistrationNumberError(err.response)
				this.$root.toast('전자세금계산서 발급 실패', err?.response?.data?.msg ?? '입력 정보를 다시 한번 확인해주세요.', 'error')
			}
		},
		// 사업자 등록 번호가 잘못된 경우 나오는 에러
		checkregistrationNumberError(response) {
			if (response?.data?.msg?.indexOf(this.regNumberErrorText) >= 0) {
				this.registrationNumberError = true
			}
		},
	},
}
</script>
<style lang="scss" scoped>
@import '@/styles/scss/license/_modal-license-card_ebil.scss';
</style>
